export const COMPARISON_LIST_SET = 'COMPARISONS_LIST_SET';
export const CURRENT_COMPARISON_SET = 'CURRENT_COMPARISON_SET';
export const NEW_COMPARISON_IDS_SET = 'NEW_COMPARISON_IDS_SET';
export const COMPARISON_FIRST_VIDEO_MOVEMENT_DATA = 'COMPARISON_FIRST_VIDEO_MOVEMENT_DATA';
export const COMPARISON_SECOND_VIDEO_MOVEMENT_DATA = 'COMPARISON_SECOND_VIDEO_MOVEMENT_DATA';
export const COMPARISON_ERROR = 'COMPARISON_ERROR';
export const COMPARISON_RESET = 'COMPARISON_RESET';
export const COMPARISON_ASSESSMENTS_ERROR = 'COMPARISON_ASSESSMENTS_ERROR';
export const COMPARISON_ASSESSMENTS = 'COMPARISON_ASSESSMENTS';
